import React, {Component, Fragment} from "react";
import {Col, Row} from "reactstrap";
import {prettyFlatObject} from "../../../util/stringhelpers";

export default class IntakesTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      view: -1,
    }
  }

  render() {
    return <div style={{overflowY: "auto", minHeight: 300, overflowWrap: "anywhere"}}>
      <h3>LMS Related Intakes</h3>
      {this.props.intakes && this.props.intakes.length === 0 && (
        <div>No Intakes found</div>
      )}
      {this.props.intakes && this.props.intakes.map((intake, index) => {
        return (<Fragment key={`${index}`}>
          <Row style={{cursor: "pointer"}} title={"Click to show more"}
               onClick={() => this.setState({view: this.state.view === index ? -1 : index})}>
            <Col lg={2} xs={3}>{`${intake.dated}`}</Col>
            <Col lg={10} xs={9}>{`${intake.source}`}</Col>
          </Row>
          {this.state.view === index && (
            <Row style={{paddingLeft: 20}}>
              <Col xs={12}>
                <pre>{`${prettyFlatObject(intake.info).join("\n")}`}</pre>
              </Col>
            </Row>
          )}
        </Fragment>)
      })}
    </div>
  }

}



// WEBPACK FOOTER //
// ./src/containers/Leads/views/IntakesTab.js